"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = void 0;
const allConfigs_1 = __importDefault(require("./allConfigs"));
function queryParamToObj(qs) {
    let queryObj = {};
    let queryParams = qs.match(/\w*=\w*/) || [];
    queryParams.forEach((qp) => {
        queryObj[qp.split('=')[0]] = qp.split('=')[1];
    });
    return queryObj;
}
function objToQueryParams(obj) {
    if (!obj)
        return "";
    return "?" + Object.keys(obj).sort().map(k => `${k}=${obj[k]}`).join('&');
}
function getConfig() {
    let queries = queryParamToObj(window.location.search);
    const isDev = window.location.host.includes("localhost") || window.location.host.includes("127.0.0");
    if (isDev) {
        return allConfigs_1.default.DEV;
    }
    return allConfigs_1.default.PROD;
}
exports.getConfig = getConfig;
